import { ListItemText, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import _ from "lodash";
import CheckboxButton from "new-components/buttons/checkbox-button";
import { HelperText } from "./helper-text";
import { useEffect, useRef, useState } from "react";


interface Option {
    id: any;
    name: string;
    disabled?: boolean
}

interface SelectCheckBoxInputProps {
    onChange: (selected: any[]) => void
    options: Option[]
    loading?: boolean
    fullWidth?: boolean
    selected: any;
    helperText?: string
    disabled?: boolean
    label?: string
    required?: boolean
    width?: string | number
    tranformOption?: boolean
    disabledAll?: boolean
    register?: any
}

export default function SelectCheckBoxInput(props: SelectCheckBoxInputProps) {

    const selectRef = useRef<HTMLDivElement>(null);
    const [menuWidth, setMenuWidth] = useState<string | number>('auto');

    useEffect(() => {
        if (selectRef.current) {
            setMenuWidth(selectRef.current.clientWidth);
        }
    }, [props.width, props.fullWidth]);

    const allOption: Option = { id: null, name: 'ทั้งหมด' };

    // 1) ไอดีของ options ที่ไม่ได้ disabled
    const selectableOptionIds = props.options
        .filter(opt => opt.id !== null && !opt.disabled)
        .map(opt => opt.id);

    // 2) ไอดีของ options ที่ disabled แต่ props.selected มีอยู่ (เช็คไว้)
    const disabledSelectedIds = props.options
        .filter(opt => opt.disabled && props.selected.includes(opt.id))
        .map(opt => opt.id);

    // สถานะ “เลือกทั้งหมด” (เฉพาะกลุ่ม selectable อย่างเดียว)
    const allSelected = selectableOptionIds.length > 0
        && selectableOptionIds.every(id => props.selected.includes(id));

    const handleChange = (event: any) => {
        const value = event.target.value as any[];

        if (value.includes(allOption.id)) {
            // กด toggle “ทั้งหมด”
            if (allSelected) {
                // เมื่อยกเลิกทั้งหมด: ลบแค่ตัวที่ selectable ออก แต่เก็บ disabledSelectedIds ไว้
                props.onChange(disabledSelectedIds);
            } else {
                // เมื่อกดเลือกทั้งหมด: เอา selectable + disabledSelectedIds
                props.onChange([...selectableOptionIds, ...disabledSelectedIds]);
            }
        } else {
            // ปกติ เลือกทีละตัว
            props.onChange(value);
        }
    };
    // const allOption: Option = { id: null, name: 'ทั้งหมด' };
    // const allSelected = props.selected?.includes(allOption?.id);


    // // นำมาข้างบนเลยเพื่อใช้ซ้ำได้หลายที่
    // const selectableOptionIds = props.options
    //     .filter(option => option.id !== null && !option.disabled)
    //     .map(option => option.id);

    // const handleChange = (event: any) => {
    //     const value = event.target.value as number[];


    //     // … ใน handleChange …
    //     if (value.includes(allOption.id)) {
    //         if (allSelected) {
    //             props.onChange([]);
    //         } else {
    //             if (selectableOptionIds.length > 0) {
    //                 // ถ้าเลือกครบแล้ว ก็ยกเลิกทั้งหมด ไม่งั้นก็เลือกเฉพาะที่ยังไม่ได้ disabled
    //                 if (selectableOptionIds.length === props.selected?.length) {
    //                     props.onChange([]);
    //                 } else {
    //                     props.onChange(selectableOptionIds);
    //                 }
    //             } else {
    //                 props.onChange([]);
    //             }
    //         }
    //     } else {
    //         props.onChange(value);
    //     }

    // };

    return (
        <FormControl ref={selectRef} sx={{ width: props.width || '100%' }} size="small" disabled={props.disabled}>
            <InputLabel
                id="demo-select-small-label"
                sx={{
                    color: props.helperText ? '#B00020' : '#808080',
                    '&.Mui-focused': {
                        color: props.helperText ? '#B00020' : '#1CB99A'
                    },
                }}
            >
                {props.label} {props.required && <span style={{ color: 'red' }}>*</span>}
            </InputLabel>
            <Select
                multiple
                error={props.helperText !== '' && props.helperText !== undefined}
                fullWidth={props.fullWidth}
                value={props.selected}
                onChange={handleChange}
                inputProps={{ value: props.selected }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            width: menuWidth
                        }
                    },
                    ...(props.tranformOption
                        ? {
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                        }
                        : {
                            disableScrollLock: true,
                            disableAutoFocusItem: true,
                            style: {
                                maxHeight: '400px'
                            }
                        })
                }}
                renderValue={(selectedIds) => {
                    if (props.options.length > 0 && selectedIds.length === props.options.length) {
                        return 'ทั้งหมด';
                    }
                    return props.options
                        .filter(option => selectedIds.includes(option.id))
                        .map(option => option.name)
                        .join(', ');
                }}
                sx={{
                    backgroundColor: props.disabled ? '#F0F0F0' : '#FFFFFF',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1CB99A',
                        borderWidth: '1px'
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#B00020',
                    },
                    '&.Mui-disabled': {
                        borderColor: '#C5C5C5',
                    },
                }}
            >
                <MenuItem key={allOption.id} value={allOption.id} disabled={props.disabledAll}>
                    <CheckboxButton
                        onChange={e => {
                            if (e.target.checked) {
                                props.onChange([...selectableOptionIds, ...disabledSelectedIds]);
                            } else {
                                props.onChange(disabledSelectedIds);
                            }
                        }}
                        checked={allSelected}
                    />
                    <ListItemText
                        primary={allOption.name}
                        sx={{
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                        }}
                    />
                </MenuItem>
                {props.loading ? (
                    <MenuItem disabled>กำลังโหลด...</MenuItem>
                ) : (
                    _.map(props.options, (item, index) => (
                        <MenuItem
                            key={index}
                            disabled={item.disabled}
                            value={item.id}
                            sx={{
                                whiteSpace: 'normal',
                                overflowWrap: 'break-word',
                                width: '100%',
                                display: 'flex',
                                alignItems: 'flex-start',
                                "&.Mui-focusVisible": {
                                    backgroundColor: '#FFFFFF'
                                },
                                '&:hover': {
                                    backgroundColor: '#EBF2F0',
                                },
                                '&.Mui-selected.Mui-focusVisible': {
                                    backgroundColor: '#EBF2F0',
                                },
                                '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                },
                                '&.Mui-selected:hover': {
                                    backgroundColor: '#EBF2F0',
                                },
                            }}
                        >
                            <CheckboxButton
                                onChange={() => null}
                                checked={props.selected.includes(item.id)}
                            />
                            <ListItemText
                                primary={item.name}
                                sx={{
                                    whiteSpace: 'normal',
                                    overflowWrap: 'break-word',
                                }}
                            />
                        </MenuItem>
                    ))
                )}
            </Select>
            {props.helperText && <HelperText label={props.helperText} />}
        </FormControl>

    )
}